/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-05-12 14:42
 */
 import Keep from "../layout/keep";
 import Layout from '../layout/layout';
 let StationManage = [
     {
         path: '/:type/detection',
         name: 'detection',
         component: Layout,
         children: [
             {
                 path: 'station',
                 name: 'station',
                 meta: { title: '站点监测' },
                 component: Keep,
                 children: [
                    {
                        path: 'list',
                        name: 'detection-station-list',
                        meta: { title: '站点监测' },
                        component: () => import('src/pages/stationList/stationList'),
                    },
                    {
                        path: 'detail',
                        name: 'detection-station-detail',
                        meta: { title: '数据查看' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationDataDetail'),
                    },
                    {
                        path: 'trendsManage',
                        name: 'detection-station-trendsManage',
                        meta: { title: '趋势管理' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationTendencyManage'),
                    },
                    {
                        path: 'stateParameter',
                        name: 'detection-station-stateParameter',
                        meta: { title: '状态参数' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationStateParams'),
                    },
                    {
                        path: 'runLog',
                        name: 'detection-station-runLog',
                        meta: { title: '运行日志' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationOperationLog'),
                    },
                    {
                        path: 'alarmLog',
                        name: 'detection-station-alarmLog',
                        meta: { title: '报警日志' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationAlarmLog'),
                    },
                    {
                        path: 'parameterLog',
                        name: 'detection-station-parameterLog',
                        meta: { title: '参数日志' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationParamsLog'),
                    },
                    {
                        path: 'video',
                        name: 'detection-station-video',
                        meta: { title: '视频监控' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationVideoMonitor'),
                    },
                    {
                        path: 'deviceCounter',
                        name: 'detection-station-deviceCounter',
                        meta: { title: '设备反控' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationDeviceControl'),
                    },
                    {
                        path: 'deviceDetail',
                        name: 'detection-station-deviceDetail',
                        meta: { title: '设备详情' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationStationSetting'),
                    },
                    {
                        path: 'alarmupper',
                        name: 'detection-station-alarmupper',
                        meta: { title: '报警上下限' },
                        component: () => import('src/pages/stationDetail/newStationDetail/StationStationAlarmupper'),
                    },
                 ],
             }
         ]
     },
 ]
 
 export default StationManage
 